import { render, staticRenderFns } from "./DeleteEmail.vue?vue&type=template&id=04ddf2fa&"
import script from "./DeleteEmail.vue?vue&type=script&lang=js&"
export * from "./DeleteEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04ddf2fa')) {
      api.createRecord('04ddf2fa', component.options)
    } else {
      api.reload('04ddf2fa', component.options)
    }
    module.hot.accept("./DeleteEmail.vue?vue&type=template&id=04ddf2fa&", function () {
      api.rerender('04ddf2fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Email/Accounts/Modals/DeleteEmail.vue"
export default component.exports